import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useFloatingBox from './useFloatingBox'

const useNetworkStatus = (theme) => {
	const { showFloatingBox, hideFloatingBox } = useFloatingBox(theme, 9999)
	const location = useLocation()

	useEffect(() => {
		if (!navigator.onLine) {
			showFloatingBox('You have lost connection!', [])
		}
	}, [location, showFloatingBox])

	useEffect(() => {
		const updateOnlineStatus = () => {
			if (navigator.onLine) {
				hideFloatingBox()
				showFloatingBox('You are back online!', [])
				setTimeout(hideFloatingBox, 5000)
			} else {
				showFloatingBox('You have lost connection!', [])
			}
		}

		window.addEventListener('online', updateOnlineStatus)
		window.addEventListener('offline', updateOnlineStatus)

		return () => {
			window.removeEventListener('online', updateOnlineStatus)
			window.removeEventListener('offline', updateOnlineStatus)
		}
	}, [showFloatingBox, hideFloatingBox])
}

export default useNetworkStatus
